import { useState } from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

import DarkMode from "./DarkMode/DarkMode";
import Logo from '../assets/logoCP.png';

export default function Navbar() {
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className='logo'>
          <a href="https://www.linkedin.com/in/azael-zamora/" target="_blank" rel="noopener noreferrer">
            <img src={Logo} alt='logo'/>
          </a>
        </div>

        <ul className='navlinks'>
          <CustomLink to="/leet-code"><b>LeetCode</b></CustomLink>
          <CustomLink to="/open-kattis"><b>Open-Kattis</b></CustomLink>
        </ul>

        <div className='mode-setting-icon'>
          <div className='dark-mode-icon'>
            <DarkMode />
          </div>
        </div>

        <div className={isNavExpanded ? "hamburger hamburger-active" : "hamburger"} onClick={() => {setIsNavExpanded(!isNavExpanded)}}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </nav>

      <div className={isNavExpanded ? "menubar active" : "menubar"}>
          <ul className='text-center'>
            <CustomLink to="/leet-code"><b>LeetCode</b></CustomLink>
            <CustomLink to="/open-kattis"><b>Open-Kattis</b></CustomLink>
          </ul>
        </div>
    </>
  )
}

function CustomLink({to, children, ...props}) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <li className={isActive ? "active": ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  )
};
